import React from 'react';
import Switch from '@mui/material/Switch';
import './styles/ToggleSwitch.css';

interface ToggleSwitchProps {
    isOn: boolean;
    onToggle: () => void;
    onLabel: string;
    offLabel: string;
}

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
    isOn,
    onToggle,
    onLabel,
    offLabel,
}) => {
    return (
        <Switch
            checked={isOn}
            onChange={onToggle}
            disableRipple
            className="custom-switch"
            icon={
                <div className="thumb-content off">
                    {offLabel}
                </div>
            }
            checkedIcon={
                <div className="thumb-content on">
                    {onLabel}
                </div>
            }
        />
    );
};

export default ToggleSwitch;
